var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('home-hero'),_c('home-welcome'),_c('home-details'),_c('home-about-me'),_c('home-pricing'),_c('home-contact'),_c('v-flex',{staticClass:"footer ma-0",attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('span',[_vm._v(" Barbara Liebscher | "),_c('router-link',{attrs:{"to":"/impressum"}},[_vm._v("Impressum")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }